import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import BeachAccessOutlinedIcon from '@mui/icons-material/BeachAccessOutlined';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import RestoreIcon from '@mui/icons-material/Restore';
import React from 'react';
import { ENotificationType } from '../enums/notifications/ENotificationType';

export const getNotificationIcon = (notificationKey: ENotificationType) => {
  if (
    [
      ENotificationType.VACATION_REQUEST_RESPONSE,
      ENotificationType.NEW_VACATION_REQUEST,
    ].includes(notificationKey)
  ) {
    return <BeachAccessOutlinedIcon />;
  }
  if (
    [
      ENotificationType.ASSIGNED_TO_NEW_PROJECT,
      ENotificationType.NEW_USER_TO_PROJECT,
      ENotificationType.REMOVED_FROM_PROJECT,
      ENotificationType.PROJECT_CANCELED,
      ENotificationType.PROJECT_FINISHED,
    ].includes(notificationKey)
  ) {
    return <AccountTreeOutlinedIcon />;
  }
  if (
    [ENotificationType.ASSIGNED_TO_NEW_DEPARTMENT].includes(notificationKey)
  ) {
    return <BadgeOutlinedIcon />;
  }
  if ([ENotificationType.NEW_EMPLOYEE_TO_COMPANY].includes(notificationKey)) {
    return <Groups2OutlinedIcon />;
  }
  if (ENotificationType.NOT_FINISHED_ATTENDANCE === notificationKey) {
    return <RestoreIcon />;
  }
  return <NotificationsActiveOutlinedIcon />;
};
